
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_368_168887)"}},[_c('path',{attrs:{"d":"M13.04 10.847l1.868.372c.02.92.778 1.65 1.694 1.63a1.663 1.663 0 001.625-1.7 1.663 1.663 0 00-1.695-1.63 1.66 1.66 0 00-1.482.99l-1.917-.383a2.735 2.735 0 00-.762-1.886l2.481-3.519c1.047.5 2.298.053 2.796-.997a2.11 2.11 0 00-.994-2.807 2.095 2.095 0 00-2.796.998 2.112 2.112 0 00.405 2.387l-2.457 3.484a2.716 2.716 0 00-3.452.544L5.128 5.815a1.672 1.672 0 00-.709-2.25 1.66 1.66 0 00-2.242.711 1.672 1.672 0 00.709 2.251 1.658 1.658 0 001.778-.156l3.288 2.563a2.74 2.74 0 00.677 3.28L6.63 15.05a2.236 2.236 0 00-3.078.756 2.254 2.254 0 00.753 3.09 2.236 2.236 0 003.078-.757 2.256 2.256 0 00-.203-2.616l2.053-2.913a2.717 2.717 0 002.23.05l2.434 3.61a1.9 1.9 0 00.074 2.678 1.882 1.882 0 002.668-.074 1.9 1.9 0 00-.074-2.678 1.882 1.882 0 00-2.08-.347l-2.4-3.558c.464-.366.8-.872.953-1.444z","fill":"#748190"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_368_168887"}},[_c('rect',{attrs:{"x":".767","y":".715","width":"18.683","height":"18.753","rx":"2.286","fill":"#fff"}})])])])
          )
        }
      }
    